export default ".text-p {\n  width: 100%;\n}\n\np {\n  text-align: justify;\n}";